import { ADDON_MAPPER } from '../config/common';

export const OLD_FEATURE_KEY_TO_ADDON_MAPPER = {
	featureRMHandbook: ADDON_MAPPER.KEYS.RM_HANDBOOK,
	featureLegalComments: ADDON_MAPPER.KEYS.LEGAL_COMMENTS,
	featureELiterature: ADDON_MAPPER.KEYS.E_LITERATURE,
	featureCompliance: ADDON_MAPPER.KEYS.COMPLIANCE, // This is "lagbevakning"
	sbtPlus: ADDON_MAPPER.KEYS.LEGAL_CASE_PLUS,
};

export const buildAddOns = (dataObject) => {
	// Start with the entity's existing add-ons
	const newAddons = dataObject.hasOwnProperty('addOns') ? [...dataObject.addOns] : [];

	// Map enabled features from the entity to add-ons
	Object.keys(OLD_FEATURE_KEY_TO_ADDON_MAPPER).forEach((featureKey) => {
		if (dataObject[featureKey]) {
			const addOnType = OLD_FEATURE_KEY_TO_ADDON_MAPPER[featureKey];

			// Add the mapped add-on type if it's not already in the entity add-ons
			if (!newAddons.map((addOn) => addOn.type).includes(addOnType)) {
				newAddons.push({
					type: addOnType,
				});
			}
		}
	});

	return newAddons;
};



// WEBPACK FOOTER //
// ./src/utils/addOnsHelper.js